import { DefaultSidebar } from "@excalidraw/excalidraw";

import "./AppSidebar.scss";

export const AppSidebar = () => {
  // Empty sidebar - all tabs removed
  return <DefaultSidebar />;
};
